(function() {
    'use strict';

a3_cabin_reports.factory('AircraftTypeFactory', AircraftTypeFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name AircraftTypeFactory
    * @description 
    *   Manage Aircraft Types.
    * @ngInject
    */
function AircraftTypeFactory(GenericValuesFactory) {

        /**
         * Initialiaze AircraftType object 
         * @memberof AircraftTypeFactory
         */
		function AircraftType() {
			this.Code = null;
		}
		var callback=AircraftType;
		var type ='aircraftTypes';
			
		var service = {
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			toObjectList : toObjectList,
			getAircraftTypesFromStorage : getAircraftTypesFromStorage,
			setAircraftTypesToStorage : setAircraftTypesToStorage
		}

        /**
         * Extend given AircraftType object 
         * @memberof AircraftTypeFactory
         * @param {object} obj The AircraftType object that will be extended
         * @returns {object} AircraftType
         */
		function fromObject(obj) {
			return GenericValuesFactory.fromObject(obj,callback);
		}

        /**
         * Extend given AircraftType object list
         * @memberof AircraftTypeFactory
         * @param {array} objList The list of AircraftType objects that will be extended
         * @returns {object} AircraftTypes
         */
		function fromObjectList(objList) {
			return GenericValuesFactory.fromObjectList(objList,callback);
		}

        /**
         * Extend given AircraftType object list
         * @memberof AircraftTypeFactory
         * @param {array} objList The list of AircraftType objects that will be extended
         * @returns {object} AircraftTypes
         */
		function toObjectList(objList) {
			return GenericValuesFactory.objList(objList);
		}

        /**
         * Get all the AircraftType objects
         * @memberof AircraftTypeFactory
         * @returns {array} AircraftTypes
         */
		function getAircraftTypesFromStorage() {
			return GenericValuesFactory.getValuesFromStorage(callback,type);
		}

        /**
         * Set all the AircraftTypes
         * @memberof AircraftTypeFactory
         * @param {array} objects A list of AircraftTypes.
         */
		function setAircraftTypesToStorage(objList) {
			GenericValuesFactory.setValuesToStorage(objList,type);
		}

	return service;
	}

})();
